// Tiny inline-SVG trend line for a 1–5 domain across recent months.
export default function Sparkline({ values, width = 96, height = 28 }) {
  const pts = (values || []).filter((v) => v != null)
  if (pts.length === 0) return <div style={{ width, height }} />
  const max = 5, min = 1
  const stepX = pts.length > 1 ? width / (pts.length - 1) : 0
  const y = (v) => height - 3 - ((v - min) / (max - min)) * (height - 6)
  const coords = pts.map((v, i) => [pts.length > 1 ? i * stepX : width / 2, y(v)])
  const path = coords.map(([x, yy], i) => `${i === 0 ? 'M' : 'L'}${x.toFixed(1)},${yy.toFixed(1)}`).join(' ')
  const [lx, ly] = coords[coords.length - 1]
  return (
    <svg width={width} height={height} style={{ display: 'block' }}>
      <path d={path} fill="none" stroke="var(--teal)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={lx} cy={ly} r="2.5" fill="var(--teal)" />
    </svg>
  )
}
